import { NavLink } from 'react-router-dom';
import { Hexagon } from 'lucide-react';
import type { Me } from '@/api/types';
import { NAV_ITEMS } from '@/app/nav';
import { cn } from '@/lib/utils';

export function SideNav({ me }: { me?: Me }) {
  const roles = new Set(me?.roles.map((r) => r.role) ?? []);
  const items = NAV_ITEMS.filter((item) => !item.roles || item.roles.some((r) => roles.has(r)));

  return (
    <nav
      aria-label="Primary"
      className="hidden w-56 shrink-0 flex-col border-r border-border bg-card px-3 py-4 md:flex"
    >
      <div className="mb-6 flex items-center gap-2 px-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary text-primary-foreground">
          <Hexagon className="h-4 w-4" aria-hidden />
        </span>
        <span className="leading-tight">
          <span className="block font-display text-sm font-semibold tracking-tight">CIGS</span>
          <span className="block text-xs text-muted-foreground">Beeline Medicines</span>
        </span>
      </div>

      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              title={item.description}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 rounded-md px-2 py-2 text-sm transition-colors duration-150',
                  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                  isActive
                    ? 'bg-accent font-medium text-accent-foreground'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground',
                )
              }
            >
              <item.icon className="h-4 w-4 shrink-0" aria-hidden />
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="mt-auto px-2 pt-6 text-xs text-muted-foreground">
        <kbd className="id-mono rounded border border-border bg-muted px-1.5 py-0.5">⌘K</kbd> to jump anywhere
      </div>
    </nav>
  );
}
